import { jsx } from 'react/jsx-runtime';

const SvgCommentBlankFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M10 22h2.11l3.36-4H22V2H2v16h8v4Z" }) }));

export { SvgCommentBlankFill as default };
//# sourceMappingURL=CommentBlankFill.es.js.map
